export default {
  list: {},
  detail: {},
  curPageNum: -1,
  curNtcFg: "",
};
